class faqBlock extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    const itemWrapper = this.querySelectorAll('.item_wrapper');
    itemWrapper.forEach((item, index) => {
      const title = item.querySelector('.item_heading');
      const content = item.querySelector('.item_content');
      title.addEventListener('click', () => {
        item.classList.toggle('active');
        if (item.classList.contains('active')) content.style.maxHeight = content.scrollHeight + 'px';
        else content.style.maxHeight = null;
        itemWrapper.forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains('active')) {
            otherItem.classList.remove('active');
            otherItem.querySelector('.item_content').style.maxHeight = null;
          }
        });
      });
      if (index === 0) {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }
}
customElements.define('faq-block', faqBlock);

(() => {
  const styleId = 'wevow-mobile-menu-fix';
  const addStyles = () => {
    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media screen and (max-width: 989px) {
        body.wh-mobile-menu-open { overflow: hidden; }
        .wevow-header .wh-mobile-overlay { position: fixed; inset: 0; z-index: 59; margin: 0; padding: 0; border: 0; background: rgba(31, 23, 21, .38); opacity: 0; visibility: hidden; pointer-events: none; transition: opacity .24s ease, visibility .24s ease; }
        .wevow-header .wh-mobile-toggle[open] .wh-mobile-overlay { opacity: 1; visibility: visible; pointer-events: auto; }
        .wevow-header .wh-mobile-panel { z-index: 60; overscroll-behavior: contain; }
        .wevow-header .wh-mobile-close { padding-right: 8px; }
        .wevow-header .wh-mobile-close-button { min-width: 48px; min-height: 48px; padding: 0 12px; border: 0; background: transparent; color: inherit; font: inherit; text-transform: inherit; letter-spacing: inherit; cursor: pointer; }
      }
      @media (prefers-reduced-motion: reduce) { .wevow-header .wh-mobile-overlay, .wevow-header .wh-mobile-panel { transition: none; } }
    `;
    document.head.appendChild(style);
  };
  const init = () => {
    addStyles();
    document.querySelectorAll('.wevow-header').forEach((root) => {
      if (root.dataset.mobileMenuFixed === 'true') return;
      const details = root.querySelector('.wh-mobile-toggle');
      const summary = root.querySelector('.wh-mobile-summary');
      const panel = root.querySelector('.wh-mobile-panel');
      const closeRow = root.querySelector('.wh-mobile-close');
      if (!details || !panel || !closeRow) return;
      root.dataset.mobileMenuFixed = 'true';
      const oldClose = closeRow.lastElementChild;
      const closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'wh-mobile-close-button focus-inset';
      closeButton.textContent = oldClose?.textContent?.trim() || 'Close';
      closeButton.setAttribute('aria-label', closeButton.textContent);
      oldClose?.replaceWith(closeButton);
      const overlay = document.createElement('button');
      overlay.type = 'button';
      overlay.className = 'wh-mobile-overlay';
      overlay.setAttribute('aria-label', closeButton.textContent);
      details.insertBefore(overlay, panel);
      const closeMenu = () => { if (!details.open) return; details.open = false; summary?.focus(); };
      closeButton.addEventListener('click', closeMenu);
      overlay.addEventListener('click', closeMenu);
      panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
      details.addEventListener('toggle', () => {
        document.body.classList.toggle('wh-mobile-menu-open', details.open);
        summary?.setAttribute('aria-expanded', String(details.open));
      });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();